import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveExit24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMoveExit24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M14.607 9.637a.9.9 0 0 0 .9.9h5.817a.9.9 0 0 0 0-1.8h-5.817a.9.9 0 0 0-.9.9m.16 3.61a.9.9 0 0 0 .9.9h3.956a.9.9 0 0 0 0-1.8h-3.956a.9.9 0 0 0-.9.9M1.99 11.837a5.55 5.55 0 0 0 5.544 5.265l.285-.008a5.551 5.551 0 1 0-5.837-5.544zm1.792-.287a3.752 3.752 0 1 1 7.505.003 3.752 3.752 0 0 1-7.505-.003"
            />
        </svg>
    );
}
export default memo(IconMoveExit24);
